import type { StateCreator } from 'zustand';
import type { PatientTabsSliceType } from '../types';
import { getVisibleIds } from '../utils/getVisibleIds';

export const setActiveTabById: StateCreator<
  PatientTabsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  PatientTabsSliceType['setActiveTabById']
> = (set, get) => (targetId) => {
  const { tabs, activeTabIndex } = get().patientTabs;
  const visibleIds = getVisibleIds(tabs);
  const targetIndex = visibleIds.indexOf(targetId);

  const isInvalidTab = targetIndex < 0;
  const isCurrentTab = targetIndex === activeTabIndex;
  if (isInvalidTab || isCurrentTab) {
    return;
  }

  set(
    (state) => {
      state.patientTabs.activeTabIndex = targetIndex;
    },
    false,
    'patientTabs/setActiveTabById',
  );
};
